import "babel-polyfill";
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider as ReduxProvider } from "react-redux";

import Router from './components/Router';
import store from './store/initStore';

import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import 'styles/dev-tools.css';
import 'styles/html-default.scss';
// tslint:disable-next-line:ordered-imports
import 'styles/main.scss';
import 'styles/reset.css';
import App from "./components/App";
import ErrorBoundary from "./components/ErrorBoundry";
import { ErrorSource } from "./service/logger/ILoggerService";
import { currentMode } from "./util/Mode";


const app = (
	<ReduxProvider store={store}>
		<Router>
			<App />
		</Router>
	</ReduxProvider>
);

const wrappd = currentMode.isDev() ? (
	<AppContainer>
		{app}
	</AppContainer>
) : (
	app
);

render(
	<ErrorBoundary type={ErrorSource.APP} location="root">
		{wrappd}
	</ErrorBoundary>,
	document.getElementById('app')
);




// WEBPACK FOOTER //
// ./src/core/Index.tsx